import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';

class Step5 extends Component {
    render() {
        return (

            <div className="card card-body">
                <div className="form-group">
                    <div className="h2">TRANSMITTING UNIT INSPECTION</div>
                    <div className="h5"><b>YES</b> - Tested Correctly || <b>NO</b> - Did Not Test Correctly || <b>NA</b> - Feature Not Available</div>
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="transIdentified"
                        label="Input Circuit Designations, Correctly Identified"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="transConnectedDevices"
                        label="Verified Correct Connected Field Devices, Plug in Components and Modules"
                    />
                </div>
                {/* <div className="form-group">
                    <ThreeOptions
                        name="transPluginModules"
                        label="Plug In Components and Modules"
                    />
                </div> */}
                <div className="form-group">
                    <ThreeOptions
                        name="transPluginCables"
                        label="Plug In Cables Securely In Place"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="transCleanliness"
                        label="Cleanliness Observed"
                    />
                </div>
                {/* new Items */}
                <div className="form-group">
                    <ThreeOptions
                        name="transGrounded"
                        label="Panel Grounded"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="elecInfoEnclosure"
                        label="Electrical Panel Location & Breaker # Listed on the Signal Transmitter Enclosure"
                    />
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className='col-sm-12 col-md-3 h5'>Electrical Panel</div>
                        <div className="col-sm-12 col-md-8">
                            <div className="form-group">
                                <label htmlFor="elecLocation">Location</label>
                                <input id="elecLocation" name="elecLocation" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-3"></div>
                        <div className="col-sm-12 col-md-4">
                            <div className="form-group">
                                <label htmlFor="elecPanelNumber">Panel #</label>
                                <input id="elecPanelNumber" name="elecPanelNumber" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4">
                            <div className="form-group">
                                <label htmlFor="elecCCT">CCT #</label>
                                <input id="elecCCT" name="elecCCT" type="text" required="required" className="form-control here" />
                            </div>
                        </div>
                    </div >

                </div >
                <div className="form-group">
                    <ThreeOptions
                        name="elecCorrectModules"
                        label="Verified Correct Connected Field Devices, Modules"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="elecConfirmSecure"
                        label="Confirm Plug-in Components connections secure"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="elecWarnLabels"
                        label="Monitoring Warning labels installed where required and visible"
                    />
                </div>
                {/* end new Items */}

                <div className="form-group">
                    <ThreeOptions
                        name="transFuses"
                        label="Fuses In Accordance With Manufacturers Specification"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="transTerminationPoints"
                        label="Termination of Wiring To Field Devices Secure"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="transInstalledProperly"
                        label="Panel installed to Manufacturers installation instructions"
                    />
                </div>
            </div>
        );
    }
}

export default Step5;



// WEBPACK FOOTER //
// ./src/components/Step5.js